import { ErrorCode, FileRejection } from 'react-dropzone';
import LangEnum from '../../../lang/LangEnum';
import { CatalogMediaDimensions } from './catalogCreationForm.types';

export const resolveCatalogCreationMediaRejectionMessage = (
  fileRejections: FileRejection[],
): LangEnum | null => {
  if (fileRejections.length === 0) {
    return null;
  }

  const isFileTooLarge = fileRejections.some(({ errors }) =>
    errors.some(({ code }) => code === ErrorCode.FileTooLarge),
  );

  if (isFileTooLarge) {
    return LangEnum.RFF_INVALID_SIZE;
  }

  return LangEnum.RFF_SELECT_VALID_FILE;
};

const getGreatestCommonDivisor = (first: number, second: number): number =>
  second === 0 ? first : getGreatestCommonDivisor(second, first % second);

export const formatCatalogMediaAspectRatio = ({ width, height }: CatalogMediaDimensions) => {
  const divisor = getGreatestCommonDivisor(width, height);

  return `${width / divisor}:${height / divisor}`;
};

export const resolveCatalogMediaFileName = (url: string) => {
  if (url.startsWith('data:')) {
    return '';
  }

  const lastSegment = url.split(/[?#]/)[0].split('/').pop() ?? '';

  try {
    return decodeURIComponent(lastSegment);
  } catch {
    return lastSegment;
  }
};
